import React, { useRef, useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import "./CalculateEmi.styles.scss";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import { VEHICLE_PRODUCT_SLIDER_IMAGE_LIST } from "../ProductPage/constants";
import { formatRupeePrice } from "../../utils/helpers/formatPrice";

const CalculateEmi = ({ containerProps, containerMethods }) => {
  const {
    downPaymentAmountLists = [],
    phoneNumber,
    errors,
    monthlyEmiAmount,
    loanTenure,
    downpaymentAmount,
  } = containerProps;
  const {
    handlePhoneNumberChange,
    handleSubmit,
    handleDownpaymentAmountChange,
    handleLoanTenureChange,
  } = containerMethods;
  const renderVehicleSliders = () => {
    return (
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        pagination={{ clickable: true }}
        loop={true}
        modules={[FreeMode, Pagination, Navigation, Thumbs]}
        className="productMainSlider"
      >
        {VEHICLE_PRODUCT_SLIDER_IMAGE_LIST?.map((sliderImage, index) => {
          return (
            <SwiperSlide
              key={index}
              style={{
                height: "225px",
                backgroundColor: "#DCDCDC",
                borderRadius: "2px",
              }}
              className="swiper-slider-main-container"
            >
              <Image
                className="product-image"
                fill
                src={sliderImage}
                alt={`sliderImage-${index}`}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  };
  const renderDownpaymenSection = () => {
    return (
      <div className="down-payment-section-main-container">
        <h5 className="down-payment-header">Downpayment</h5>
        <div className="down-payment-amount-list-container">
          {downPaymentAmountLists?.map((amount, index) => {
            return (
              <button
                className={`down-payment-amount-button ${
                  amount?.value == downpaymentAmount ? "active" : ""
                }`}
                key={index}
                onClick={() => handleDownpaymentAmountChange(amount.value)}
              >
                {amount?.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  };
  const renderLoanTenureSection = () => {
    return (
      <div className="loan-tenure-main-section">
        <h5 className="loan-tenure-header">Loan Tenure</h5>
        <div className="loan-tenure-list-container">
          {[12, 24, 28, 36, 42, 48]?.map((item, index) => {
            return (
              <button
                className={`loan-tenure-button ${
                  item === loanTenure ? "active" : ""
                }`}
                key={`${item}-${index}`}
                onClick={() => {
                  handleLoanTenureChange(item);
                }}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  const renderDownPaymentEMiSection = () => {
    return (
      <div className="downpayment-emi-section-main-container">
        <div className="downPayment-value-section">
          <span className="downpayment-label">Downpayment</span> -{" "}
          <span className="downpayment-value">
            Rs {formatRupeePrice(downpaymentAmount)}
          </span>
        </div>
        <div className="emi-value-section">
          <span className="emi-label">EMI / Month</span> -{" "}
          <span className="emi-value">
            Rs {formatRupeePrice(monthlyEmiAmount)}
          </span>
        </div>
      </div>
    );
  };

  const renderGetQuoteForm = () => {
    return (
      <div className="get-quote-form-container">
        <form id="get-quote-form" onSubmit={handleSubmit}>
          <div className="phone-input">
            <span className="prefix">+91</span>
            <input
              type="tel"
              placeholder="XXX XXX XXXX"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
            />
          </div>
          <button type="submit">Get Quote</button>
        </form>
        {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
      </div>
    );
  };
  return (
    <div className="calculate-emi-main-container">
      {renderVehicleSliders()}
      {renderDownpaymenSection()}
      {renderLoanTenureSection()}
      {renderDownPaymentEMiSection()}
      {renderGetQuoteForm()}
    </div>
  );
};

export default CalculateEmi;
